import styled from "styled-components";

import { layout, space, border, flexbox, background } from "styled-system";

export const Card = styled.div`
  ${space};
  ${border};
  ${layout};
  ${flexbox};
  ${background};
`;
